import React from 'react';
import ReactDOM from 'react-dom';
import { BrowserRouter } from 'react-router-dom'
import './index.css';
import App from './App';
import registerServiceWorker from './registerServiceWorker';
import apiBaseUrl from './utils/apiBaseUrl'
import { ApolloProvider } from 'react-apollo';
import { ApolloClient } from 'apollo-client';
import { HttpLink } from 'apollo-link-http';
import { InMemoryCache } from 'apollo-cache-inmemory';
import { setContext } from 'apollo-link-context';
import { from } from 'apollo-link';
import 'url-search-params-polyfill';

const urlParams = new URLSearchParams(window.location.search)

const authLink = setContext((_, { headers }) => {
  const token = urlParams.get('token')
  return {
    headers: {
      ...headers,
      Authorization: token ? ` Token ${token}` : null,
    }
  }
});

const httpLink = new HttpLink({ uri: apiBaseUrl + '/graphql'})

const client = new ApolloClient({
  link: from([
    authLink,
    httpLink
  ]),
  cache: new InMemoryCache(),
});

const ApolloApp = () => {
  return (
    <ApolloProvider client={client}>
      <BrowserRouter>
        <App/>
      </BrowserRouter>
    </ApolloProvider>
  )
}

ReactDOM.render(<ApolloApp />, document.getElementById('root'));
registerServiceWorker();



// WEBPACK FOOTER //
// ./src/index.js